import React from 'react';
import { useTranslation } from 'react-i18next';
import { socialLinks } from '../../data/socialLinks';
import { videos } from '../../data/videos';
import VideoCard from './VideoCard';
import './Videos.css';

const Videos = () => {
  const { t } = useTranslation();

  return (
    <section className="videos section" id="videos">
      <div className="container">
        <h2 className="section-title">{t('videos.title')}</h2>
        <div className="videos-grid">
          {videos.length > 0 ? (
            videos.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))
          ) : (
            <div className="videos-placeholder">
              <p>{t('videos.watchOnYouTube')}</p>
              <a 
                href={socialLinks.youtube} 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn-primary"
              >
                Visit YouTube Channel
              </a>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Videos;

